module.exports = __webpack_public_path__ + "static/media/horoscope-icon-8.1d48c99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-8.png
// module id = 1534
// module chunks = 0